import * as service from './service'
export default {
  namespace: 'honourKnightTaskList',
  state: {
    demoData: {}
  },
  effects: {
    * attendScoreTasks ({ payload }, { call, put }) {
      const res = yield call(service.attendScoreTasks, payload)
      if (res.data.status === 200) {
        return res.data.data
      }
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
